const WORDS = [
  "OFFICE FLOORS",
  "RETAIL FLOORS",
  "MEDICAL SUITES",
  "WAREHOUSES",
  "DATA CENTERS",
  "SHOWROOMS",
  "LOBBIES",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="border-b border-line bg-ink-900 py-6 md:py-8 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="outline-text font-display font-black tracking-tight text-5xl md:text-7xl px-8">
              {w}
            </span>
            <span className="h-2.5 w-2.5 bg-acid rotate-45 shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
};
